// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { SettingGroup } from '../../../../../com/MetaPattern/APP/MDA/User/SettingGroup';
import { User } from '../../../../../com/MetaPattern/APP/MDA/User/User';
import { Tenancy } from '../../../../../com/MetaPattern/APP/MDA/User/Tenancy';
import { UserSetting } from '../../../../../com/MetaPattern/APP/MDA/User/UserSetting';
import { SettingItem } from '../../../../../com/MetaPattern/APP/MDA/User/SettingItem';
import { SelectGroup } from '../../../../../com/MetaPattern/APP/MDA/User/SelectGroup';
import { AccountInfoDTO } from '../../../../../com/MetaPattern/APP/MDA/User/AccountInfoDTO';
import { RegistInfoDTO } from '../../../../../com/MetaPattern/APP/MDA/User/RegistInfoDTO';
import { get, post } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
class SaveUserSettingsDTO {
  userSettings: Array<UserSetting>;

  public toJson(): any {
    const json: any = {};
    json.UserSettings = [];
    this.userSettings.forEach((item) => {
      if (item.toJson) {
        json.UserSettings.push(item.toJson());
      } else {
        json.UserSettings.push(item);
      }
    });
    return json;
  }
}
class RegistUserDTO {
  registInfo: RegistInfoDTO;

  public toJson(): any {
    const json: any = {};
    if (this.registInfo.toJson) {
      json.RegistInfo = this.registInfo.toJson();
    } else {
      json.RegistInfo = this.registInfo;
    }
    return json;
  }
}
class UserInitDTO {
  workscopeName: string;
  workscopeDisplayName: string;
  sysGitUrl: string;
  sysGitBranchName: string;
  sysGitUsername: string;
  sysGitPassword: string;

  public toJson(): any {
    const json: any = {};
    json.WorkscopeName = this.workscopeName;
    json.WorkscopeDisplayName = this.workscopeDisplayName;
    json.SysGitUrl = this.sysGitUrl;
    json.SysGitBranchName = this.sysGitBranchName;
    json.SysGitUsername = this.sysGitUsername;
    json.SysGitPassword = this.sysGitPassword;
    return json;
  }
}
/**
 * MDA用户服务 服务类
 * MDA用户服务
 */
export class MDAUserService {
  static async GetSettingGroupsAsync(): Promise<Array<SettingGroup> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/mdauserservice/getsettinggroups')
        .then((response: any) => {
          let result: Array<SettingGroup> | null = null;
          if (response) {
            const items = new Array<SettingGroup>();
            response.forEach((item: any) => {
              const element = SettingGroup.Create(item);
              if (item.Parent !== null) {
                element.parent = SettingGroup.Create(item.Parent);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetUserAndSettingsAsync(loginAccountId: string): Promise<Array<User> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/mdauserservice/getuserandsettings', { loginAccountId: loginAccountId })
        .then((response: any) => {
          let result: Array<User> | null = null;
          if (response) {
            const items = new Array<User>();
            response.forEach((item: any) => {
              const element = User.Create(item);
              if (item.Tenancy !== null) {
                element.tenancy = Tenancy.Create(item.Tenancy);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async SaveUserSettingsAsync(userSettings: Array<UserSetting>): Promise<Array<UserSetting> | null> {
    return new Promise((resolve, reject) => {
      const dto = new SaveUserSettingsDTO();
      dto.userSettings = userSettings;
      post('metapattern-ide-mda/service/mdauserservice/saveusersettings', dto.toJson())
        .then((response: any) => {
          let result: Array<UserSetting> | null = null;
          if (response) {
            const items = new Array<UserSetting>();
            response.forEach((item: any) => {
              const element = UserSetting.Create(item);
              if (item.User !== null) {
                element.user = User.Create(item.User);
              }
              if (item.SettingItem !== null) {
                element.settingItem = SettingItem.Create(item.SettingItem);
              }
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetSelectGroupsAsync(): Promise<Array<SelectGroup> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/mdauserservice/getselectgroups')
        .then((response: any) => {
          let result: Array<SelectGroup> | null = null;
          if (response) {
            const items = new Array<SelectGroup>();
            response.forEach((item: any) => {
              const element = SelectGroup.Create(item);
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async RegistUserAsync(registInfo: RegistInfoDTO): Promise<AccountInfoDTO | null> {
    return new Promise((resolve, reject) => {
      const dto = new RegistUserDTO();
      dto.registInfo = registInfo;
      post('metapattern-ide-mda/service/mdauserservice/registuser', dto.toJson())
        .then((response: any) => {
          let result: AccountInfoDTO | null = null;
          if (response) {
            result = AccountInfoDTO.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async UserIsInitAsync(): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/mdauserservice/userisinit')
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async UserInitAsync(workscopeName: string, workscopeDisplayName: string, sysGitUrl: string, sysGitBranchName: string, sysGitUsername: string, sysGitPassword: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new UserInitDTO();
      dto.workscopeName = workscopeName;
      dto.workscopeDisplayName = workscopeDisplayName;
      dto.sysGitUrl = sysGitUrl;
      dto.sysGitBranchName = sysGitBranchName;
      dto.sysGitUsername = sysGitUsername;
      dto.sysGitPassword = sysGitPassword;
      post('metapattern-ide-mda/service/mdauserservice/userinit', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
